import { useAuthEmployeeQuery } from "./useAuthEmployeeQuery"

export function useNewSupportFlow() {
  const { data } = useAuthEmployeeQuery()
  const enabledAt = data?.company?.newSupportFlowEnabledAt ?? null

  return {
    enabledAt,
    isEnabled: enabledAt !== null,
  }
}
